// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetPESServiceConfigForRegionByID200Response,
  ListAllPESAvailableRegions200Response,
  SubmitEnablePESForRegion202Response,
} from '../models/index';
import {
  ErrorResponseFromJSON,
  ErrorResponseToJSON,
  GetPESServiceConfigForRegionByID200ResponseFromJSON,
  GetPESServiceConfigForRegionByID200ResponseToJSON,
  ListAllPESAvailableRegions200ResponseFromJSON,
  ListAllPESAvailableRegions200ResponseToJSON,
  SubmitEnablePESForRegion202ResponseFromJSON,
  SubmitEnablePESForRegion202ResponseToJSON,
} from '../models/index';

export interface DeletePESServiceForRegionByIDRequest {
  organizationId: string;
  projectId: string;
  regionId: string;
}

export interface GetPESServiceConfigForRegionByIDRequest {
  organizationId: string;
  projectId: string;
  regionId: string;
}

export interface ListAllPESAvailableRegionsRequest {
  organizationId: string;
  projectId: string;
}

export interface ListAllPESEnabledRegionsRequest {
  organizationId: string;
  projectId: string;
}

export interface SubmitEnablePESForRegionRequest {
  organizationId: string;
  projectId: string;
  regionId: string;
}

/**
 *
 */
export class PrivateEndpointServiceApi extends runtime.BaseAPI {
  /**
   * Delete the Private Endpoint Service configuration for a given Aura Organization and Aura Project in a region.
   * Delete the Private Endpoint Service configuration for a given Aura Organization and Aura Project in a region.
   */
  async deletePESServiceForRegionByIDRaw(
    requestParameters: DeletePESServiceForRegionByIDRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetPESServiceConfigForRegionByID200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling deletePESServiceForRegionByID().',
      );
    }

    if (requestParameters['projectId'] == null) {
      throw new runtime.RequiredError(
        'projectId',
        'Required parameter "projectId" was null or undefined when calling deletePESServiceForRegionByID().',
      );
    }

    if (requestParameters['regionId'] == null) {
      throw new runtime.RequiredError(
        'regionId',
        'Required parameter "regionId" was null or undefined when calling deletePESServiceForRegionByID().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/organizations/{organization_id}/projects/{project_id}/private-endpoint-service/regions/{region_id}`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'project_id'}}`,
      encodeURIComponent(String(requestParameters['projectId'])),
    );
    urlPath = urlPath.replace(
      `{${'region_id'}}`,
      encodeURIComponent(String(requestParameters['regionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetPESServiceConfigForRegionByID200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Delete the Private Endpoint Service configuration for a given Aura Organization and Aura Project in a region.
   * Delete the Private Endpoint Service configuration for a given Aura Organization and Aura Project in a region.
   */
  async deletePESServiceForRegionByID(
    requestParameters: DeletePESServiceForRegionByIDRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetPESServiceConfigForRegionByID200Response> {
    const response = await this.deletePESServiceForRegionByIDRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Obtain the information about the Private Endpoint Service configuration for a given Aura Organization and Aura Project in a region.  Returns a status of *__not_assigned__* if the service has not been enabled for the project, *__in_progress__* while the configuration is being enabled and *__assigned__* once the service has been enabled.  The service name is used by the consumer to connect to the producer service.
   * Get the configuration of the Private Endpoint Service for a given Aura Organization and Aura Project in a region.
   */
  async getPESServiceConfigForRegionByIDRaw(
    requestParameters: GetPESServiceConfigForRegionByIDRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetPESServiceConfigForRegionByID200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling getPESServiceConfigForRegionByID().',
      );
    }

    if (requestParameters['projectId'] == null) {
      throw new runtime.RequiredError(
        'projectId',
        'Required parameter "projectId" was null or undefined when calling getPESServiceConfigForRegionByID().',
      );
    }

    if (requestParameters['regionId'] == null) {
      throw new runtime.RequiredError(
        'regionId',
        'Required parameter "regionId" was null or undefined when calling getPESServiceConfigForRegionByID().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/organizations/{organization_id}/projects/{project_id}/private-endpoint-service/regions/{region_id}`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'project_id'}}`,
      encodeURIComponent(String(requestParameters['projectId'])),
    );
    urlPath = urlPath.replace(
      `{${'region_id'}}`,
      encodeURIComponent(String(requestParameters['regionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetPESServiceConfigForRegionByID200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Obtain the information about the Private Endpoint Service configuration for a given Aura Organization and Aura Project in a region.  Returns a status of *__not_assigned__* if the service has not been enabled for the project, *__in_progress__* while the configuration is being enabled and *__assigned__* once the service has been enabled.  The service name is used by the consumer to connect to the producer service.
   * Get the configuration of the Private Endpoint Service for a given Aura Organization and Aura Project in a region.
   */
  async getPESServiceConfigForRegionByID(
    requestParameters: GetPESServiceConfigForRegionByIDRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetPESServiceConfigForRegionByID200Response> {
    const response = await this.getPESServiceConfigForRegionByIDRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Lists the regions that support the Private Endpoint Service functionality that can be enabled for a given Aura Organization and Aura Project.
   * Get the list of regions that support Private Endpoint Service and are available for a customer to enable the service in.
   */
  async listAllPESAvailableRegionsRaw(
    requestParameters: ListAllPESAvailableRegionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ListAllPESAvailableRegions200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling listAllPESAvailableRegions().',
      );
    }

    if (requestParameters['projectId'] == null) {
      throw new runtime.RequiredError(
        'projectId',
        'Required parameter "projectId" was null or undefined when calling listAllPESAvailableRegions().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/organizations/{organization_id}/projects/{project_id}/private-endpoint-service/regions`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'project_id'}}`,
      encodeURIComponent(String(requestParameters['projectId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ListAllPESAvailableRegions200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Lists the regions that support the Private Endpoint Service functionality that can be enabled for a given Aura Organization and Aura Project.
   * Get the list of regions that support Private Endpoint Service and are available for a customer to enable the service in.
   */
  async listAllPESAvailableRegions(
    requestParameters: ListAllPESAvailableRegionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ListAllPESAvailableRegions200Response> {
    const response = await this.listAllPESAvailableRegionsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Lists the regions that have been enabled for Private Endpoint Service for a given Aura Organization and Aura Project.
   * Get the list of regions that have been enabled for Private Endpoint Service for a given Aura Organization and Aura Project.
   */
  async listAllPESEnabledRegionsRaw(
    requestParameters: ListAllPESEnabledRegionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ListAllPESAvailableRegions200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling listAllPESEnabledRegions().',
      );
    }

    if (requestParameters['projectId'] == null) {
      throw new runtime.RequiredError(
        'projectId',
        'Required parameter "projectId" was null or undefined when calling listAllPESEnabledRegions().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/organizations/{organization_id}/projects/{project_id}/private-endpoint-service/regions/enabled`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'project_id'}}`,
      encodeURIComponent(String(requestParameters['projectId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ListAllPESAvailableRegions200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Lists the regions that have been enabled for Private Endpoint Service for a given Aura Organization and Aura Project.
   * Get the list of regions that have been enabled for Private Endpoint Service for a given Aura Organization and Aura Project.
   */
  async listAllPESEnabledRegions(
    requestParameters: ListAllPESEnabledRegionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ListAllPESAvailableRegions200Response> {
    const response = await this.listAllPESEnabledRegionsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Submit a request to enable the Private Endpoint Service for an Aura Organization and Aura Project in a given region.
   * Request enabling the Private Endpoint Service for a given Aura Organization and Aura Project in a given region.
   */
  async submitEnablePESForRegionRaw(
    requestParameters: SubmitEnablePESForRegionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetPESServiceConfigForRegionByID200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling submitEnablePESForRegion().',
      );
    }

    if (requestParameters['projectId'] == null) {
      throw new runtime.RequiredError(
        'projectId',
        'Required parameter "projectId" was null or undefined when calling submitEnablePESForRegion().',
      );
    }

    if (requestParameters['regionId'] == null) {
      throw new runtime.RequiredError(
        'regionId',
        'Required parameter "regionId" was null or undefined when calling submitEnablePESForRegion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/organizations/{organization_id}/projects/{project_id}/private-endpoint-service/regions/{region_id}`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'project_id'}}`,
      encodeURIComponent(String(requestParameters['projectId'])),
    );
    urlPath = urlPath.replace(
      `{${'region_id'}}`,
      encodeURIComponent(String(requestParameters['regionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetPESServiceConfigForRegionByID200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Submit a request to enable the Private Endpoint Service for an Aura Organization and Aura Project in a given region.
   * Request enabling the Private Endpoint Service for a given Aura Organization and Aura Project in a given region.
   */
  async submitEnablePESForRegion(
    requestParameters: SubmitEnablePESForRegionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetPESServiceConfigForRegionByID200Response> {
    const response = await this.submitEnablePESForRegionRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
